import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import IsMobileContext from "../contexts/is-mobile-context";
import { useSafeSetState } from "@evertrue/et-components";

const initialState = { items: [] };
const prop_list = ["poolId", "limit", "sortBy", "sortOrder"];

const AnalyticsDataResolver = props => {
  const [analyticsData, setAnalyticsData] = useSafeSetState(initialState);
  const [loading, setLoading] = useSafeSetState(null);
  const [page, setPage] = React.useState(1);
  const isFetching = React.useRef(false);
  const isMobile = React.useContext(IsMobileContext);
  const offset = props.limit * (page - 1);

  const fetchAnalyticsData = () => {
    setLoading(true);
    if (isFetching.current) return;
    isFetching.current = true;
    props.promises
      .fetchAnalytics({ ..._.pick(props, prop_list), offset, limit: props.limit, name: props.nameQuery })
      .then(res => {
        isFetching.current = false;
        if (isMobile) {
          setAnalyticsData(prevState => {
            return { ...res, items: [...prevState.items, ...res.items] };
          });
        } else {
          setAnalyticsData(res);
        }
        setLoading(false);
      })
      .catch(() => {
        isFetching.current = false;
        setLoading(false);
      });
  };

  const handlePageChange = page => {
    if (analyticsData.total === analyticsData.items.length) return;
    setPage(page);
  };

  // when name changes and is non falsy, clear state

  React.useEffect(() => {
    setPage(1);
    // on infinite scroll with a name query
    if (props.nameQuery && isMobile) {
      setAnalyticsData(initialState);
    }
  }, [isMobile, props.nameQuery, setAnalyticsData]);

  React.useEffect(fetchAnalyticsData, [props.nameQuery, props.poolId, props.sortBy, props.sortOrder, page]);

  return props.children({ data: analyticsData, loading, fetchAnalyticsData, handlePageChange, page });
};

AnalyticsDataResolver.propTypes = {
  nameQuery: PropTypes.string,
  sortBy: PropTypes.string,
  poolId: PropTypes.number,
  limit: PropTypes.number,
};

AnalyticsDataResolver.defaultProps = {
  nameQuery: "",
};

export default AnalyticsDataResolver;
